"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
const ahoyBlue_1 = __importDefault(require("./ahoyBlue"));
const appTheme = (0, styles_1.createTheme)({
    palette: {
        primary: ahoyBlue_1.default,
        text: {
            primary: '#18355B',
        },
    },
    typography: {
        fontFamily: 'Poppins',
        fontWeightLight: 400,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 700,
        h1: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 700,
        },
        h2: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 600,
        },
        h3: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 500,
        },
        h4: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 300,
            fontSize: '1.25rem',
        },
        h5: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 400,
        },
        h6: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 400,
        },
        body1: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 400,
        },
        body2: {
            fontFamily: 'Poppins',
            color: '#18355B',
            fontWeight: 400,
        },
    },
});
exports.default = appTheme;
